import { PhoneInput } from '@repo/videa-components/src/index';
import { Label } from '@repo/videa-components/src/ui/label';
import { Controller, useFormContext } from 'react-hook-form';

interface PhoneInputFieldProps {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  defaultCountry?: string;
}

export const PhoneInputField = ({
  name,
  label,
  required = false,
  disabled = false,
  placeholder = 'Enter phone number',
  defaultCountry = 'CA',
}: PhoneInputFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];

  return (
    <div className="vai-space-y-1">
      <Label htmlFor={name} className="vai-text-sm">
        {label}
        {required && <span className="vai-text-red-500">*</span>}
      </Label>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? `${label} is required` : false,
          validate: (value) => {
            if (!value) return true; // Let required rule handle empty values
            // Basic phone validation - at least 10 digits
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length < 10) {
              return 'Please enter a valid phone number';
            }
            return true;
          },
        }}
        render={({ field }) => (
          <PhoneInput
            {...field}
            placeholder={placeholder}
            defaultCountry={defaultCountry}
            error={!!error}
            disabled={disabled}
            className="vai-h-8 vai-text-sm"
          />
        )}
      />
      {error && (
        <p className="vai-text-red-500 vai-text-xs vai-mt-1">
          {error.message as string}
        </p>
      )}
    </div>
  );
};
